import { legacy_createStore as createStore, applyMiddleware } from 'redux'
import { thunk } from 'redux-thunk'
import { composeWithDevTools } from '@redux-devtools/extension';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import rootReducer from './reducers'
import * as actions from "./auth/AuthActions";

// Middleware imports
import validateDPServiceFormMiddleware from "./middlewares/veritas-middleware/add-edit-form-middlewares/ValidateDPServiceFormMiddleware";
import apiMiddlewareDPServices from "./middlewares/veritas-middleware/api-middlewares/apiMiddlewareDPServices";
import validateDataProviderFormMiddleware from "./middlewares/veritas-middleware/add-edit-form-middlewares/ValidateDataProviderFormMiddleware";
import apiMiddlewareDataProvider from "./middlewares/veritas-middleware/api-middlewares/apiMiddlewareDataProvider";
import activityLoggerMiddleware from "./middlewares/utility-middlewares/ActivityLoggerMiddleware";
import checkUpdateMiddleware from "./middlewares/utility-middlewares/CheckUpdateMiddleware";
import validateDPSourcesFormMiddleware from "./middlewares/veritas-middleware/add-edit-form-middlewares/ValidateDPSourcesFormMiddleware";
import apiMiddlewareDPSources from "./middlewares/veritas-middleware/api-middlewares/apiMiddlewareDPSources";
import reportGenerationMiddleware from "./middlewares/report-gen-middleware/ReportGenerationMiddleware";
import approvalsMiddleware from "./middlewares/utility-middlewares/ApprovalsMiddleware";
import testcacheMiddleware from "./middlewares/support-middleware/TestcacheMiddleware";
import KYBTestCacheMiddleware from "./middlewares/support-middleware/KYBTestCacheMiddleware";
import txDebugLogsMiddleware from "./middlewares/support-middleware/TxDebugLogsMiddleware";
import billingOrganizationsMiddleware from "./middlewares/billing-middleware/BillingOrganizationsMiddleware";
import validateBillingOrgFormMiddleware from "./middlewares/billing-middleware/ValidateBillingOrgFormMiddleware";
import apiMiddlewareCountries from "./middlewares/veritas-middleware/api-middlewares/apiMiddlewareCountries";
import pricingTablesMiddleware from "./middlewares/billing-middleware/PricingTablesMiddleware";
import validateCountryFormMiddleware
    from "./middlewares/veritas-middleware/add-edit-form-middlewares/ValidateCountryFormMiddleware";
import apiMiddlewareBillingGroups from "./middlewares/veritas-middleware/api-middlewares/apiMiddlewareBillingGroups";
import validateBillingGroupFormMiddleware
from "./middlewares/veritas-middleware/add-edit-form-middlewares/ValidateBillingGroupFormMiddleware";
import apiMiddlewareBillingGroupsPricing from 'middlewares/veritas-middleware/api-middlewares/apiMiddlewareBillingGroupsPricing';
import manualEntryRecordsMiddleware from "./middlewares/billing-middleware/ManualEntryRecordsMiddleware";
import billingReportsMiddleware from "./middlewares/billing-middleware/BillingReportMiddleware";


// Assets
import './styles/styles.global.scss'

// Enables tracing of Redux Actions.
const composeEnhancers = composeWithDevTools({trace: true, traceLimit: 25 })
// hold all the middlewares together here
const middlewares = [
    validateDPServiceFormMiddleware,
    apiMiddlewareDPServices,
    validateDataProviderFormMiddleware,
    apiMiddlewareDataProvider,
    validateDPSourcesFormMiddleware,
    apiMiddlewareDPSources,
    activityLoggerMiddleware,
    apiMiddlewareCountries,
    validateCountryFormMiddleware,
    checkUpdateMiddleware,
    reportGenerationMiddleware,
    approvalsMiddleware,
    testcacheMiddleware,
    KYBTestCacheMiddleware,
    txDebugLogsMiddleware,
    billingOrganizationsMiddleware,
    validateBillingOrgFormMiddleware,
    pricingTablesMiddleware,
    apiMiddlewareBillingGroups,
    validateBillingGroupFormMiddleware,
    apiMiddlewareBillingGroupsPricing,
    manualEntryRecordsMiddleware,
    billingReportsMiddleware,
]

// configuration for persisting the object on the local storage
// added versioning to redux. Only accepts upto one decimal point.
// the app will clear state and refresh automatically if the version cached in user's browser does not
// match what is on the deployed app.
// small updates increment by lower decimal ex. 2.12, 2.13
// if a reducer/middleware is added update the higher decimal ex. 2.20, 2.30
const persistConfig = {
    key: 'root',
    storage: storage,
    version: 4.17,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

let store = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(thunk, ...middlewares)),
);

let persistor = persistStore(store)

export { store, actions, persistor, persistConfig }
